$(document).ready(() => {
  const emailLinks = document.querySelectorAll('a[href*="mailto:"]')
  const phoneLinks = document.querySelectorAll('a[href*="tel:"]')
  const whatsAppLinks = document.querySelectorAll('a[href*="api.whatsapp"]')
  const externalDineBooking = document.querySelectorAll('.room-list.restaurant .room-ctas .book')
  const restaurantReserveBooking = document.querySelectorAll('.restaurant-detail .restaurant-reserve-cta a')
  const externalSpaBooking = document.querySelectorAll('.carousel .slide-ctas a')
  const fmoAccountLocations = document.querySelector('#account-locations')

  // Any Emails links
  if (emailLinks) {
    emailLinks.forEach((link) => {
      if (link.href.includes('mailto:')) {
        customEventClickTag(link, 'contactEmail')
      }
    })
  }
  // Any Phone links
  if (phoneLinks) {
    phoneLinks.forEach((link) => {
      if (link.href.startsWith('tel:')) {
        customEventClickTag(link, 'contactPhone')
      }
    })
  }

  if (whatsAppLinks) {
    whatsAppLinks.forEach((link) => {
      customEventClickTag(link, 'contactWhatsApp')
    })
  }

  // External CTAs for dine
  if (externalDineBooking) {
    externalDineBooking.forEach((link) => {
      const href = link.getAttribute('href')
      if (href && new URL(href).hostname !== location.hostname) {
        customEventClickTag(link, 'diningResFormSub')
      }
    })
  }

  // External CTAs for Restaurant Page Booking
  if (restaurantReserveBooking) {
    restaurantReserveBooking.forEach((link) => {
      customEventClickTag(link, 'diningResFormSub')
    })
  }

  // target should alwyas contain 'spasoft'
  if (externalSpaBooking) {
    externalSpaBooking.forEach((link) => {
      if (link.target.includes('spasoft')) {
        customEventClickTag(link, 'spaResFormSub')
      }
    })
  }

  // Locations the user is interested in
  // if (fmoAccountLocations) {
  //   interestedLocationsEventClick(fmoAccountLocations)
  // }

  function customEventClickTag(link, eventType) {
    const linkEmail = link.href.replace('mailto:', '')
    const linkPhone = link.href.replace('tel:+', '')
    const linkWhatsApp = link.href.replace('https://api.whatsapp.com/send/?phone=', '')
    link.addEventListener('click', () => {
      if (window.adobeDataLayer) {
        switch (eventType) {
          case 'contactEmail':
            window.adobeDataLayer.push({
              event: eventType,
              emailLink: linkEmail
            })
            break
          case 'contactPhone':
            window.adobeDataLayer.push({
              event: eventType,
              telephoneLink: linkPhone
            })
            break
          case 'contactWhatsApp':
            window.adobeDataLayer.push({
              event: eventType,
              whatsAppLink: linkWhatsApp
            })
            break
          case 'spaResFormSub':
            const targetName = link.closest('.slide-content').querySelector('.slide-title').textContent.trim()
            window.adobeDataLayer.push({
              event: eventType,
              spaTreatment: targetName || ''
            })
            break
          case 'diningResFormSub':
            let restaurantName = ""
            if (link.closest('.room-item')) {
              restaurantName = link.closest('.room-item').querySelector('.room-title').textContent.trim()
            } else if (link.closest(".restaurant-detail-wrapper")) {
              restaurantName = link.closest(".restaurant-detail-wrapper").querySelector(".restaurant-name").textContent.trim()
            }

            window.adobeDataLayer.push({
              event: eventType,
              restaurant: restaurantName || ''
            })
            break
          default:
            window.adobeDataLayer.push({
              event: eventType
            })
        }
      }
    })
  }

  // Tracking customer's interested locations using Adobe DTM
  let newSelectedLocations = []

  function sendAdobeDataLayerEvent(selectedLocations) {
    selectedLocations.forEach((item) => {
      window.adobeDataLayer.push({
        event: 'miscAction',
        action: {
          name: 'FOMO interested-in',
          detail: item,
        },
        user: {
          ...window.DefaultDataLayer.user,
        },
      });
    });
  }

  function handleCheckboxClick(checkbox) {
    const destinationNameElement = checkbox.closest('.destination-list-card')?.querySelector('.destination-name')
    const destinationName = destinationNameElement ? destinationNameElement.textContent : null

    if (!destinationName) return;

    if (checkbox.checked) {
      newSelectedLocations.push(destinationName)
    } else {
      const index = newSelectedLocations.indexOf(destinationName)
      if (index > -1) {
        newSelectedLocations.splice(index, 1)
      }
    }
  }

  function interestedLocationsEventClick(container) {
    const openModalCta = container.querySelector('.account-information-field-cta__add')
    openModalCta.addEventListener('click', function (event) {
      newSelectedLocations = []
    });

    container.addEventListener('click', function (event) {
      const { target } = event;

      if (target.type === 'checkbox' && target.closest('.destination-list-card-checkbox')) {
        handleCheckboxClick(target)
      }
      if (target.classList.contains('confirm-cta') && target.closest('.modal-wrapper')) {
        sendAdobeDataLayerEvent(newSelectedLocations)
      }
    });
  }
})
